export interface TimelineMilestone {
  year: string;
  title: string;
  body: string;
  image?: { src: string; alt: string; credit?: string };
  link?: { label: string; href: string };
}

export const TIMELINE: TimelineMilestone[] = [
  {
    year: "2021",
    title: "Founded on the Docks",
    body: "Started as a weekend stand connecting three fishing families to their neighbors.",
  },
  {
    year: "2022",
    title: "First Cold-Chain Route",
    body: "Built our own ice-packed courier network to guarantee same-day freshness.",
  },
  {
    year: "2023",
    title: "20 Partner Boats",
    body: "Expanded to twenty fishing crews across three coastal regions.",
  },
  {
    year: "2025",
    title: "12 Cities & Growing",
    body: "Now delivering traceable, sustainable seafood across 12 coastal cities.",
    link: { label: "See where we deliver", href: "/locations" },
  },
];
